<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack()">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="主办审核" prop="verify">
              <el-radio-group
                  v-model="ruleForm.verify"
                  @change="getVerifyRadio"
              >
                <el-radio :label="0">未审核</el-radio>
                <el-radio :label="1">已审核</el-radio>
                <el-radio :label="2">审核不通过</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公安审核" prop="disabled">
              <el-radio-group
                  v-model="ruleForm.disabled"
                  @change="getDisabledRadio"
              >
                <el-radio :label="0">未审核</el-radio>
                <el-radio :label="1">已审核</el-radio>
                <el-radio :label="2">审核不通过</el-radio>
                <el-radio :label="3">无效身份证</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="注册类型" prop="type" v-if="!show">
              <el-select
                  placeholder="注册类型："
                  clearable
                  v-model="ruleForm.type"
                  class="el-input-position"
              >
                <el-option
                    v-for="(item, index) in types"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册通道" prop="registerId" v-if="!show">
              <el-select
                  placeholder="注册通道："
                  clearable
                  v-model="ruleForm.registerId"
                  class="el-input-position"
                  v-on:change="selectItem($event)"
              >
                <el-option
                    v-for="(item, index) in registers"
                    :key="index"
                    v-if="item.type==ruleForm.type"
                    :label="item.name"
                    :value="item.registerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="documentTypeId" label="证件类型" v-if="!show">
              <el-select
                  v-model="ruleForm.documentTypeId"
                  placeholder="证件类型"
                  disabled
              >
                <el-option
                    v-for="(type, index) in DocumentType"
                    :label="type.name"
                    :key="index"
                    :value="type.documentTypeId"
                >{{ type.name }}
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否支付">
              <el-switch :disabled="true" v-model="ruleForm.pay">
              </el-switch>
            </el-form-item>
            <el-form-item label="是否领队" v-if="isTeam">
              <el-radio-group
                  v-model="ruleForm.leader"
              >
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg0"
                :editImg="editImg0"
                :imgTitle="imgTitle0"
            ></UploadImg>
            <el-form-item v-if="ruleForm.url" label="支付凭证">
              <el-image :src="ruleForm.url"></el-image>
            </el-form-item>
            <el-form-item label="支付凭证" prop="url">
              <el-input v-model="ruleForm.url"></el-input>
            </el-form-item>
            <el-form-item v-if="isTeam" label="团队名称">
              <el-autocomplete
                  v-model="ruleForm.team"
                  value-key="company"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入团队公司名称"
                  @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="公司机构" prop="company">
              <el-input :disabled="isTeam" v-model="ruleForm.company"></el-input>
            </el-form-item>
            <el-form-item v-if="!show" label="团组类型">
              <el-select
                  clearable
                  filterable
                  v-model="ruleForm.groupUserId"
                  class="el-input-position"
                  @change="handleChange($event)"
              >
                <el-option
                    v-for="(item, index) in groupUsers"
                    :key="index"
                    :label="item.name"
                    :value="item.groupUserId"
                    @click="select(item)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="团组名称" prop="groupNo" v-if="!ruleForm.groupUserId">
              <el-input v-model="ruleForm.groupNo"></el-input>
            </el-form-item>
            <el-form-item label="证件类型名称" prop="documentType">
              <el-input v-model="ruleForm.documentType"></el-input>
            </el-form-item>
            <el-form-item label="人员编码" prop="code">
              <el-input v-model="ruleForm.code"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="人员姓名" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="英文姓名" prop="nameEn">
              <el-input v-model="ruleForm.nameEn"></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
            <el-form-item v-if="ruleForm.avatar" label="头像">
              <el-image :src="ruleForm.avatar"></el-image>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
              <el-input v-model="ruleForm.avatar"></el-input>
            </el-form-item>
            <el-form-item label="原图" prop="originalImg">
              <el-input v-model="ruleForm.originalImg"></el-input>
            </el-form-item>
            <el-form-item label="性别/称呼" prop="sex">
              <el-input v-model="ruleForm.sex"></el-input>
            </el-form-item>
            <el-form-item label="有效证件类型" prop="department">
              <el-select
                  placeholder="有效证件类型："
                  clearable
                  v-model="ruleForm.department"
                  class="el-input-position"
              >
                <el-option
                    v-for="(item, index) in departments"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="idCard">
              <el-input v-model="ruleForm.idCard"></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg1"
                :editImg="editImg1"
                :imgTitle="imgTitle1"
            ></UploadImg>
            <el-form-item label="展位号码" prop="booth">
              <el-input v-model="ruleForm.booth"></el-input>
            </el-form-item>
            <el-form-item label="公司英文" prop="companyEn">
              <el-input v-model="ruleForm.companyEn"></el-input>
            </el-form-item>
            <el-form-item label="职务/职位" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="职务英文" prop="positionEn">
              <el-input v-model="ruleForm.positionEn"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item label="施工证类型" prop="construction">
              <el-input v-model="ruleForm.construction"></el-input>
            </el-form-item>
            <el-form-item label="施工证" prop="electrician">
              <el-input v-model="ruleForm.electrician"></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg2"
                :editImg="editImg2"
                :imgTitle="imgTitle2"
            ></UploadImg>
            <el-form-item label="车牌号" prop="carNo">
              <el-input v-model="ruleForm.carNo"></el-input>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg3"
                :editImg="editImg3"
                :imgTitle="imgTitle3"
            ></UploadImg>
            <el-form-item label="国家/地区" prop="countryArea">
              <el-input v-model="ruleForm.countryArea"></el-input>
            </el-form-item>
            <el-form-item label="省份" prop="province">
              <el-input v-model="ruleForm.province"></el-input>
            </el-form-item>
            <el-form-item label="城市" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
            <el-form-item label="区/县" prop="area">
              <el-input v-model="ruleForm.area"></el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
            <el-form-item label="地址英文" prop="addressEn">
              <el-input v-model="ruleForm.addressEn"></el-input>
            </el-form-item>
            <el-form-item label="注册来源" prop="source">
              <el-input v-model="ruleForm.source"></el-input>
            </el-form-item>
            <el-form-item label="标签" prop="openId">
              <el-input v-model="ruleForm.openId"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="ruleForm.remark"></el-input>
            </el-form-item>
            <el-form-item label="备注1" prop="remark">
              <el-input v-model="ruleForm.remark1"></el-input>
            </el-form-item>
            <el-form-item label="备注2" prop="remark">
              <el-input v-model="ruleForm.remark2"></el-input>
            </el-form-item>
            <el-form-item label="备注3" prop="remark">
              <el-input v-model="ruleForm.remark3"></el-input>
            </el-form-item>
            <el-form-item label="备注4" prop="remark">
              <el-input v-model="ruleForm.remark4"></el-input>
            </el-form-item>
            <el-form-item label="备注5" prop="remark">
              <el-input v-model="ruleForm.remark5"></el-input>
            </el-form-item>
            <el-form-item label="参与论坛" prop="market">
              <el-input v-model="ruleForm.market"></el-input>
            </el-form-item>
            <el-form-item label="座位号" prop="visit">
              <el-input v-model="ruleForm.visit"></el-input>
            </el-form-item>
            <el-form-item label="行政级别" prop="profile">
              <el-input v-model="ruleForm.profile"></el-input>
            </el-form-item>
            <el-form-item label="业务范围" prop="business">
              <el-input v-model="ruleForm.business"></el-input>
            </el-form-item>
            <el-form-item label="三要素核验" prop="status">
              <el-input v-model="ruleForm.status"></el-input>
            </el-form-item>
            <el-form-item label="二要素核验" prop="status2">
              <el-input v-model="ruleForm.status2"></el-input>
            </el-form-item>
            <el-form-item label="重点核验" prop="zd">
              <el-input v-model="ruleForm.zd"></el-input>
            </el-form-item>
            <div v-if="isReception">
              <el-form-item label="接机接站">
                <el-select placeholder="是否接机接站：" v-model="ruleForm.isReception">
                  <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="抵达方式">
                <el-input
                    v-model="ruleForm.arrivalMethod"
                    placeholder="抵达方式"
                ></el-input>
              </el-form-item>
              <el-form-item label="抵达地点">
                <el-input
                    v-model="ruleForm.arrivalLocation"
                    placeholder="抵达地点"
                ></el-input>
              </el-form-item>
              <el-form-item label="抵达班次">
                <el-input
                    v-model="ruleForm.arrivalGrades"
                    placeholder="抵达班次"
                ></el-input>
              </el-form-item>
              <el-form-item label="抵达日期">
                <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.arrivalDate"
                    placeholder="抵达日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="抵达时间">
                <el-time-select
                    value-format="HH:mm"
                    :picker-options="{start: '06:00',step: '00:05',end: '23:00'}"
                    v-model="ruleForm.arrivalTime"
                    placeholder="抵达时间"
                ></el-time-select>
              </el-form-item>
              <el-form-item label="是否接到">
                <el-select placeholder="是否接到：" v-model="ruleForm.isReceived">
                  <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接到时间">
                <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.receivedTime"
                    placeholder="接到时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="接机人">
                <el-input
                    v-model="ruleForm.receivedName"
                    placeholder="接机人"
                ></el-input>
              </el-form-item>
              <el-form-item label="接机人手机">
                <el-input
                    v-model="ruleForm.receivedPhone"
                    placeholder="接机人手机"
                ></el-input>
              </el-form-item>
              <el-form-item label="接机人车牌">
                <el-input
                    v-model="ruleForm.receivedCarNo"
                    placeholder="接机人手机"
                ></el-input>
              </el-form-item>
              <el-form-item label="接机车型">
                <el-input
                    v-model="ruleForm.receivedCar"
                    placeholder="接机车型"
                ></el-input>
              </el-form-item>
              <el-form-item label="接机车型">
                <el-input
                    v-model="ruleForm.receivedCar"
                    placeholder="接机车型"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机送站">
                <el-select placeholder="是否送机送站：" v-model="ruleForm.isGive">
                  <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="送机日期">
                <el-date-picker
                    v-model="ruleForm.giveDate"
                    type="datetime"
                    width="100"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="送机时间">
                <el-time-select
                    value-format="HH:mm"
                    :picker-options="{start: '06:00',step: '00:05',end: '23:00'}"
                    v-model="ruleForm.giveTime"
                    placeholder="送机时间"
                ></el-time-select>
              </el-form-item>
              <el-form-item label="送机方式">
                <el-input
                    v-model="ruleForm.giveMethod"
                    placeholder="送机方式送机方式"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机地点">
                <el-input
                    v-model="ruleForm.giveLocation"
                    placeholder="送机地点"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机班次">
                <el-input
                    v-model="ruleForm.giveGrades"
                    placeholder="送机班次"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机人">
                <el-input
                    v-model="ruleForm.giveName"
                    placeholder="送机人"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机人手机">
                <el-input
                    v-model="ruleForm.givePhone"
                    placeholder="送机人手机"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机人车型">
                <el-input
                    v-model="ruleForm.giveCar"
                    placeholder="送机人车型"
                ></el-input>
              </el-form-item>
              <el-form-item label="送机人车牌">
                <el-input
                    v-model="ruleForm.giveCarNo"
                    placeholder="送机人车牌"
                ></el-input>
              </el-form-item>
              <el-form-item label="送达时间">
                <el-date-picker
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="ruleForm.deliveryTime"
                    placeholder="送达时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否送达">
                <el-select
                    placeholder="是否送达："
                    clearable
                    v-model="ruleForm.isDelivery"
                    class="el-input-position"
                >
                  <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入住酒店">
                <el-select
                    placeholder="是否入住酒店："
                    v-model="ruleForm.isCheckIn"
                    class="el-input-position"
                >
                  <el-option v-for="item in options" :value="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="酒店名称">
                <el-input
                    v-model="ruleForm.hotel"
                    placeholder="酒店名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="房间类型">
                <el-input
                    v-model="ruleForm.roomType"
                    placeholder="房间类型"
                ></el-input>
              </el-form-item>
              <el-form-item label="房间号">
                <el-input
                    v-model="ruleForm.roomNo"
                    placeholder="房间号"
                ></el-input>
              </el-form-item>
              <el-form-item label="入住酒店时间">
                <el-date-picker
                    v-model="ruleForm.checkInTime"
                    type="datetime"
                    width="100"
                    value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="离开酒店时间">
                <el-date-picker
                    v-model="ruleForm.departureTime"
                    type="datetime"
                    width="100"
                    value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../public/UploadImg";
import checkPhone from "../common/checkPhone";

export default {
  name: "editexhibiorspersonal",
  data() {
    return {
      projectId: localStorage.getItem("project_Id"),
      right: localStorage.getItem("roles").toString() === "编辑人员",
      show: localStorage.getItem("roles").toString() === "团组",
      documentTypeName: localStorage.getItem("typeName"),
      documentTypeId: localStorage.getItem("documentTypeId"),
      registerId: localStorage.getItem("registerId"),
      DocumentType: [],
      registers: [],
      groupUsers: [],
      types: [
        {name: "组委会", value: "1"},
        {name: "展商", value: "2"},
        {name: "展团/代表团", value: "3"},
        {name: "观众", value: "4"},
        {name: "媒体", value: "5"},
        {name: "嘉宾", value: "6"},
        {name: "搭建商", value: "7"},
        {name: "服务商", value: "8"},
        {name: "撤展人员", value: "9"},
        {name: "兼职/志愿者/外协", value: "10"},
        {name: "会议/论坛/活动", value: "11"},
        {name: "其他", value: "12"},
      ],
      departments: [
        {name: "中国居民身份证", value: "中国居民身份证"},
        {name: "港澳台居民居住证", value: "港澳台居民居住证"},
        {name: "港澳来往通行证", value: "港澳来往通行证"},
        {name: "台湾来往通行证", value: "台湾来往通行证"},
        {name: "通行护照", value: "通行护照"},
        {name: "其它", value: "其它"},
      ],
      isReception: false,
      isTeam: false,
      rules: {
        documentTypeId: [
          {required: true, message: "证件类型不能为空", trigger: "blur"},
        ],
        disabled: [{required: true, message: "禁用状态不能为空", trigger: "blur"}],
        verify: [{required: true, message: "审核状态不能为空", trigger: "blur"}],
        // name: [{required: true, message: "姓名不能为空", trigger: "blur"}],
        registerId: [{required: true, message: "注册通道不能为空", trigger: "blur"}],
        type: [{required: true, message: "请选择类型", trigger: "blur"}],
        // position: [{required: false, message: "职务不能为空", trigger: "blur"}],
        //phone: [{ required: false, validator: checkPhone, trigger: "blur" }],
      },
      restaurants: [],
      options: [{name: '是', value: 1}, {name: '否', value: 0}],
      ruleForm: {
        team: "",
        label: "",
        leader: 0,
        isReception: 0,
        isReceived: 0,
        isCheckIn: 0,
        exhibitorId: null,
        isGive: 0,
        isDelivery: 0,
        pay: false,
        url: "",
        arrivalGrades: "",
        arrivalDate: "",
        receivedName: "",
        receivedPhone: "",
        receivedCarNo: "",
        receivedCar: "",
        giveTime: "",
        arrivalTime: "",
        arrivalLocation: "",
        giveLocation: "",
        checkInTime: "",
        receivedTime: "",
        deliveryTime: "",
        giveDate: "",
        giveMethod: "",
        giveGrades: "",
        giveName: "",
        givePhone: "",
        giveCar: "",
        giveCarNo: "",
        arrivalMethod: "",
        departureTime: "",
        construction: "",
        electrician: "",
        electricianUrl: "",
        idCardUrl: "",
        carNo: "",
        carUrl: "",
        name: "",
        phone: "",
        company: "",
        position: "",
        nameEn: "",
        companyEn: "",
        positionEn: "",
        addressEn: "",
        countryArea: "",
        groupNo: "",
        province: "",
        city: "",
        area: "",
        email: "",
        avatar: "",
        originalImg: "",
        idcard: "",
        department: "", state: "",
        code: "",
        batch: localStorage.getItem("accountId"),
        openId: "",
        phoneNo: "",
        remark: "",
        remark1: "",
        remark2: "",
        remark3: "",
        remark4: "",
        remark5: "",
        lang: "",
        address: "",
        source: "",
        type: "4",
        booth: "",
        verify: 0,
        disabled: 0,
        sourceId: "0",
        business: "",
        profile: "",
        status: "",
        status2: "",
        zd: "",
        visit: "",
        projectId: localStorage.getItem("project_Id"),
        registerId: localStorage.getItem("roles").toString() === "团组" ? localStorage.getItem("registerId") : null,
        documentTypeId: localStorage.getItem("roles").toString() === "团组" ? localStorage.getItem("documentTypeId") : null,
        documentType: localStorage.getItem("roles").toString() === "团组" ? localStorage.getItem("documentType") : null,
        groupUserId: localStorage.getItem("roles").toString() === "团组" ? localStorage.getItem("groupUserId") : null,
      },
      editImg: "",
      editImg0: "",
      editImg1: "",
      editImg2: "",
      editImg3: "",
      personal_Id: "",
      imgTitle: "上传头像",
      imgTitle0: "上传支付凭证",
      imgTitle1: "身份证图片",
      imgTitle2: "施工证图片",
      imgTitle3: "行驶证图片",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  created() {
    this.getDocumentType();
    this.loadData();
    this.getExhibitor('-')
  },
  watch: {
    $route: "getPath",
    editData: function () {
      const item = this.editData;
      if (item) {
        this.ruleForm.batch = this.right ? localStorage.getItem("accountId") : "";
        this.ruleForm = this.editData;
        this.ruleForm.type = item.type.toString();
        this.personal_Id = item.personalId;
        this.selectItem(this.ruleForm.registerId);
        this.get(this.ruleForm.personalId)
      }
    },
  },
  methods: {
    querySearchAsync(queryString, callback) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      callback(results);
      if (queryString !== this.ruleForm.company) {
        this.ruleForm.exhibitorId = null;
      }
      console.log(this.ruleForm.company, queryString, this.ruleForm.exhibitorId)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.company.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.ruleForm.exhibitorId = item.exhibitorId;
      this.ruleForm.company = item.company;
      this.ruleForm.team = item.company;
    },
    getExhibitor(name) {
      this.$axios
          .get("/Exhibitor/Company/" + this.projectId + "/" + name + "/")
          .then((res) => {
            if (res.data.hasError == false) {
              this.restaurants = [...res.data.data]
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });
    },
    select(item) {
      this.ruleForm.groupNo = item.name
    },
    selectItem(item) {
      this.registers.forEach((i) => {
        if (i.registerId == item) {
          this.isReception = i.isReception === 1;
          this.isTeam = (i.isTeam === 1);
          this.ruleForm.documentTypeId = i.documentTypeId;
        }
      })
    },
    handleChange(e) {
      this.ruleForm.groupNo = '';
      this.groupUsers.forEach(item => {
        if (item.groupUserId == e) {
          this.ruleForm.groupNo = item.name
        }
      })
    },
    get(id) {
      this.$axios
          .get("/Personal/" + id)
          .then((res) => {
            if (res.data.hasError == false) {
              this.ruleForm = res.data.data
              this.ruleForm.type = this.ruleForm.type.toString();
              this.personal_Id = this.ruleForm.personalId;
              if (this.ruleForm.exhibitorId) {
                this.ruleForm.team = this.ruleForm.company;
              }
              this.editImg = this.ruleForm.avatar;
              this.editImg1 = this.ruleForm.idCardUrl;
              this.editImg3 = this.ruleForm.carUrl;
              this.editImg2 = this.ruleForm.electricianUrl;
              this.$forceUpdate();
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });
    },
    loadData() {
      this.$axios
          .get("/Register/Project/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.registers = [...res.data.data];
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });

      this.$axios
          .get("/GroupUser/" + this.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.groupUsers = [...res.data.data];
            } else {
              console.log(res.data.message);
            }
          })
          .catch(function () {
          });
    },

    getDocumentType() {
      this.$axios
          .get("/DocumentType/Project/" + this.ruleForm.projectId)
          .then((res) => {
            if (res.data.hasError == false) {
              this.DocumentType = [...res.data.data];
            }
          });
    },
    getDisabledRadio(value) {
      this.ruleForm.disabled = value;
    },
    getVerifyRadio(value) {
      this.ruleForm.verify = value;
    },
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.personal_Id == "" || this.personal_Id == undefined) {
            this.$axios.post("/Personal/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/Personal/" + this.personal_Id + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                  } else {
                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.personal_Id = "";
      this.ruleForm.avatar = "";
      this.$refs.ruleForm.resetFields();
    },
    getUploadImg(imgSrc) {
      this.ruleForm.avatar = imgSrc;
    },
    getUploadImg0(imgSrc) {
      this.ruleForm.url = imgSrc;
    },
    getUploadImg1(imgSrc) {
      this.ruleForm.idCardUrl = imgSrc;
    },
    getUploadImg2(imgSrc) {
      this.ruleForm.electricianUrl = imgSrc;
    },
    getUploadImg3(imgSrc) {
      this.ruleForm.carUrl = imgSrc;
    },
    getType(value) {
      this.ruleForm.type = value;
    },
  },
  components: {
    UploadImg,
  },
};
</script>